import type { ChipEvaluation } from '@/components/task/eval-chip';
import type { FeedbackState } from '@agavi/blocks';

/**
 * WORST WINS: one verdict for a block that fired several states.
 *
 * `incorrect` beats `neutral` beats `correct`, because a block that got something wrong got
 * something wrong however much else it got right -- a student reading "correct" beside a wrong
 * part would be told the opposite of what happened.
 *
 * Lifted out of `preview-submission.tsx` when the debug panel needed the same reading. Two
 * copies of this ordering is two answers to "how did this block do", and the verdict dialog and
 * the panel sit on screen at the same time.
 */
const SEVERITY: Record<string, number> = { incorrect: 3, neutral: 2, correct: 1 };

/** Null where the block fired nothing at all, which is "not answered" rather than a verdict. */
export function worstEvaluation(states: readonly FeedbackState[] | undefined): ChipEvaluation | null {
  let worst: ChipEvaluation | null = null;
  for (const state of states ?? []) {
    const evaluation = (state.evaluation ?? 'neutral') as ChipEvaluation;
    if (!worst || (SEVERITY[evaluation] ?? 0) > (SEVERITY[worst] ?? 0)) worst = evaluation;
  }
  return worst;
}
